/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Subscriptions_CountInputs */

const en_admin_subscriptions_count = /** @type {(inputs: Admin_Subscriptions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} subscriptions`)
};

/**
* | output |
* | --- |
* | "{count} subscriptions" |
*
* @param {Admin_Subscriptions_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_count = /** @type {((inputs: Admin_Subscriptions_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_count(inputs)
});
export { admin_subscriptions_count as "admin.subscriptions.count" }